import { Box } from '@mui/material'
import { styled as muiStyled } from '@mui/material/styles'
import { dark, thirdly3, thirdly4 } from 'styles/theme'

export const AssessmentCostsStyles = muiStyled(Box)(({ theme }) => ({
    overflow: "auto",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    rowGap: 20,

    '.top-card': {
        display: "flex",
        flexDirection: "column",
        rowGap: 16,
        padding: 16,
        borderRadius: 16,
        border: "1px solid #E8EEF6",
        background: "#FFF",
    },

    '.stats-row': {
        display: "flex",
        columnGap: 16,
    },

    '.stat-tile': {
        display: "flex",
        flexDirection: "column",
        rowGap: 4,
        padding: "12px 20px",
        borderRadius: 12,
        background: 'var(--Surface-card-secondary-hover, #EAF3FF)',
        border: `1px solid ${thirdly3}`,
        minWidth: 180,
    },

    '.stat-label': {
        fontSize: 14,
        color: dark,
    },

    '.stat-value': {
        fontSize: 22,
        fontWeight: "bold",
        color: dark,
    },

    '.comparison-section': {
        display: "flex",
        flexDirection: "column",
        rowGap: 12,
        padding: 16,
        borderRadius: 16,
        border: "1px solid #E8EEF6",
        background: "#FFF",
    },

    '.comparison-title': {
        fontSize: 16,
        fontWeight: 700,
    },

    '.costs-table': {
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #E8EEF6",

        'th, td': {
            padding: "16px",
            textAlign: "center",
            borderBottom: "1px solid #E8EEF6",
            borderLeft: "1px solid #E8EEF6",
        },

      
        'tr:last-of-type td': {
            borderBottom: "none",
        },

        th: {
            fontSize: 16,
            color: dark,
            fontWeight: 700,
        },

        td: {
            fontSize: 16,
            fontWeight: 400,
        },
    },

    '.category-cell': {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        columnGap: 8,
    },

    '.category-icon': {
        width: 20,
        height: 20,
    },

    '.loading-container': {
        display: "flex",
        justifyContent: "center",
        padding: 40,
    },

    '.empty-state': {
        padding: 40,
        textAlign: "center",
        color: dark,
    },
}))
